<script>
import FavoriteAction from './FavoriteAction.vue';

export default {
    name: 'CollapsibleSection',
    components: {
        FavoriteAction,
    },
    data() {
        return {
            isCollapsed: true,
        };
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
    },
};
</script>
